export default "__VITE_ASSET__BLR_8ZzE__"